import {createFileRoute} from '@tanstack/react-router';

import PatientDelete from '@/practitioner/views/patient/PatientDelete';

export const Route = createFileRoute('/(practitioner)/patients/$patientId/delete')({
  component: PatientDelete,
  loader: ({params}) => ({
    patientId: params.patientId
  })
});
